import { getAlpha2WithExceptions } from '@/components/Checkout/_helpers/functions/getAlpha2WithExceptions'
import type { Alpha2CountryCode } from '@/lib/types/alpha2CountryCode'
import type { SendRequestType } from '@/lib/utils/shared/httpTools'
import httpTools from '@/lib/utils/shared/httpTools'

type Props = {
  market: Alpha2CountryCode
  hydraToken: string
}

export type PaymentMethodInfo = {
  methodDetails: {
    alias: string
    aliasIsAssociatedWithAutoOrder: boolean
    creditCardExpires: string
    creditCardNetwork: string
    creditCardNumberMasked: string
    payer: string
    creditCardNumber: string
  }
  billToAddress: {
    address1: string
    address2: string
    city: string
    state: string
    zip: string
    country: Alpha2CountryCode
  }
  billToEmail: string
  billToName: {
    firstName: string
    lastName: string
  }
  billToPhone: string
  href: string
}

export type HydraGetCreditCardsResponse = PaymentMethodInfo[]

export const HydraGetCreditCards = ({ market, hydraToken }: Props) => {
  const request: SendRequestType = {
    method: 'GET',
    url: `/customers/me/creditcardaliases/${getAlpha2WithExceptions({
      alpha2: market,
    })}`,
    token: hydraToken,
  }

  return httpTools.sendRequest<HydraGetCreditCardsResponse>(request)
}
